import React, { useState } from 'react';
import { Checkbox } from '@carbon/react';
import { CaretDown, CaretRight } from '@carbon/react/icons';
import classNames from 'classnames';

import style from './map.module.scss';

interface CollapsibleSectionProps {
  id: string;
  title: string;
  checked: boolean;
  indeterminate?: boolean;
  onChange: (
    _evt: React.ChangeEvent<HTMLInputElement>,
    data: { checked: boolean }
  ) => void;
  children?: React.ReactNode;
  isHeaderOnly?: boolean;
  defaultOpen?: boolean;
  showCheckbox?: boolean;
  disabled?: boolean;
  className?: string;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  id,
  title,
  checked,
  indeterminate,
  onChange,
  children,
  isHeaderOnly = false,
  defaultOpen = false,
  showCheckbox = true,
  disabled = false,
  className,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleSection = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div
        className={classNames(style.titleArea, {
          [style.headerOnly]: !showCheckbox,
          [className || '']: !!className,
        })}
      >
        <div className={style.allCheckBox}>
          {showCheckbox ? (
            <div className={style.collapsibleHeader}>
              <Checkbox
                id={id}
                disabled={disabled}
                labelText={
                  <div className={style.labelWithIcon}>
                    {!isHeaderOnly && (
                      <span
                        className={classNames(style.collapseIcon, {
                          [style.collapseIconDisabled]: disabled,
                        })}
                        onClick={disabled ? undefined : toggleSection}
                        onMouseDown={(e) => e.preventDefault()}
                        data-testid={`caret-${id}`}
                      >
                        {isOpen ? <CaretDown /> : <CaretRight />}
                      </span>
                    )}
                    <span
                      className={classNames({
                        [style.labelWithoutIcon]: isHeaderOnly,
                      })}
                    >
                      {title}
                    </span>
                  </div>
                }
                checked={checked}
                indeterminate={indeterminate}
                onChange={onChange}
              />
            </div>
          ) : (
            <div
              className={classNames(style.collapsibleHeader, {
                [style.noCheckbox]: !showCheckbox,
              })}
              onClick={!isHeaderOnly ? toggleSection : undefined}
            >
              <div className={style.headerText}>
                {!isHeaderOnly && (
                  <span
                    className={style.collapseIcon}
                    data-testid={`caret-${id}`}
                  >
                    {isOpen ? <CaretDown /> : <CaretRight />}
                  </span>
                )}
                <span>{title}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {!isHeaderOnly && (
        <div
          id={`section-${id}`}
          className={classNames(style.groupChecks, {
            [style.collapsed]: !isOpen,
          })}
        >
          {isOpen && children}
        </div>
      )}
    </>
  );
};

export { CollapsibleSection };
